<div class="inner-container contact-us">
  <div class="card">
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
      <div class="grid formgrid">
        <div class="col-12 mb-4">
          <p class="contact-title">{{ 'CONTACT.contactUs' | translate }}</p>
        </div>
        <div class="col-12 md:col-6 field mb-4 pr-2">
          <app-input
            [control]="getContactControl('first_name')"
            type="text"
            label="{{ 'COMMON.firstName' | translate }}"
            name="First name"
          ></app-input>
        </div>
        <div class="col-12 md:col-6 field mb-4 pl-2">
          <app-input
            [control]="getContactControl('last_name')"
            type="text"
            label="{{ 'COMMON.lastName' | translate }}"
            name="Last name"
          ></app-input>
        </div>
        <div class="col-12 md:col-6 field mb-4 pr-2">
          <app-input
            id="email"
            [control]="getContactControl('email')"
            type="email"
            label="{{ 'COMMON.emailAddress' | translate }}"
            name="Email"
          ></app-input>
        </div>
        <div class="col-12 md:col-6 field mb-4 pl-2">
          <app-input
            [control]="getContactControl('order_uuid')"
            type="text"
            label="Order ID"
            name="Order UUID"
          ></app-input>
        </div>
        <div class="col-12 field mb-4">
          <label for="message" class="block mb-2 message-label">Message</label>
          <textarea
            id="message"
            formControlName="message"
            rows="5"
            pTextarea
            class="w-full message-area"
            placeholder="Your message..."
            [ngClass]="{
              'ng-dirty': contactForm.get('message')?.dirty,
              'ng-invalid invalid-textarea':
                contactForm.get('message')?.invalid && contactForm.get('message')?.touched
            }"
          ></textarea>
          @if (contactForm.get('message')?.invalid && contactForm.get('message')?.touched) {
            <p class="textarea-msg-error">Message is required</p>
          }
        </div>
        <div class="col-12 field mb-4 custom-upload">
          <p-fileUpload
            #fileUploader
            name="image-uploader"
            [multiple]="false"
            [customUpload]="true"
            (onSelect)="onFileSelect($event)"
            accept="image/*"
            maxFileSize="10485760"
            showUploadButton="false"
            styleClass="surface-card p-0  mb-1"
          >
            <ng-template #content>
              <div class="min-h-10 m-1 py-4">
                <!-- If no image is selected, show clickable upload area -->
                @if (!imagePreview) {
                  <a
                    href="#"
                    (click)="
                      $event.preventDefault(); fileUploader.advancedFileInput.nativeElement.click()
                    "
                  >
                    <div
                      class="flex flex-column w-full h-full justify-content-center align-items-center cursor-pointer p-3 gap-3"
                    >
                      <img
                        class="upload-icon"
                        src="assets/img/icons/upload.png"
                        alt="Upload File"
                      />
                      <span>Drop or select an image</span>
                    </div>
                  </a>
                }
                <!-- If an image is selected, show preview with a remove button -->
                @if (imagePreview) {
                  <div class="flex justify-content-center align-items-center h-full w-full">
                    <div class="flex justify-content-center w-full px-4">
                      <img
                        [src]="imagePreview"
                        height="80"
                        alt="Contact image"
                        style="max-width: 100%; max-height: 100%; object-fit: contain"
                      />
                    </div>
                    <button
                      pButton
                      type="button"
                      aria-label="remove"
                      icon="pi pi-times"
                      class="p-button-rounded p-button-primary text-sm absolute justify-content-center align-items-center"
                      style="top: 10px; right: 10px"
                      (click)="removeImage($event)"
                    ></button>
                  </div>
                }
              </div>
            </ng-template>
          </p-fileUpload>
        </div>
      </div>
      <div class="flex justify-content-start">
        <app-button
          type="submit"
          label="Send"
          [fullWidth]="true"
          [ngStyle]="{ width: '200px' }"
          [loading]="isLoadingSubmit"
          [disabled]="isLoadingSubmit"
        ></app-button>
      </div>
    </form>
  </div>
</div>
